import React, { useState,useEffect, useContext  } from "react";

import { useNavigate, useLocation  } from 'react-router-dom';
import Modal from "react-bootstrap/Modal";
import Button from 'react-bootstrap/Button'
import ReactGA from 'react-ga4';
import SignupForm from '../form/signupForm';
import Doi from '../doi/doi';
import Lang from '../lang/translations';
import Context from '../context/context';
import helpers from '../_helpers/helpersFunction';

import ImpostaRegione from './component/impostaRegione'






export default function PopupHook(props) {
	

	const [country, SetCountry] = useState(helpers.getCountry());
	let navigate = useNavigate();
	var location = useLocation();
    location = location.pathname.split("/")
	const  context = useContext(Context)

	const {collection_folder, default_folder} = helpers.getCDNfolder()

	if(props.angel){
		var imageUrl =  process.env.REACT_APP_CDN+"/"+default_folder+"/" + props.angel.id + ".jpg";	
	}
	

	if(props.provenienza == "blurred"){
		
				
		return ( <Modal
		  {...props}
		  size="md"
		  aria-labelledby="contained-modal-title-vcenter"
		  centered
		  dialogClassName="popuphook fineCrediti"
		  animation={false}
		>
		  <Modal.Body>
			<div className="popupbackground" style={{backgroundImage: `url(${imageUrl})` }} >
				<span className="closeHook" onClick={()=>{context.setModalShowHook(false);}}>X</span>
				<div className="contentBackground ">
					<div className="hookTextContainer">
					<div className="contenitoreMessaggioAlert">
							<p><i className="fa fa-exclamation-triangle"> </i> <Lang w={"blurred_title"} page={"popupHook"}/></p>
							<img src={imageUrl} alt="" className="imageInHook"/>
						</div>
				
						<br></br>
						<h3><Lang w={"blurred_incentive"} page={"popupHook"} placeholders={{angel:props.angel.screenName}}/></h3>
					</div>
					<Button onClick={() => {
						//ReactGA.event({ category: 'User',action: 'Click su hook',label:'Messaggio offuscato'})
						context.setPaymentPageText({...context.paymentPageText,text1:""});
						context.setRateplanScelto(context.rateplanScelto)
						navigate('/vip_plan/'+context.flusso.hooks.blurred);
						context.setModalShowHook(false)}}>
						 <Lang w={"continua"} page={"popupHook"}/>
					</Button>
				</div>
			</div>
		  </Modal.Body>
		</Modal>);
	}
	if(props.provenienza == "paginazione"){
		
		return ( <Modal
		  {...props}
		  size="lg"
		  aria-labelledby="contained-modal-title-vcenter"
		  centered
		  dialogClassName="popuphook"
		  animation={false}
		>
		  <Modal.Body>
			<div className="popupbackground" style={{backgroundColor:`rgba(0,0,0,0.8)`}}>
				<span className="closeHook" onClick={()=>{context.setModalShowHook(false);}}>X</span>
				<div className="contentBackground ">
					<div className="hookTextContainer">
						<h4><Lang w={"altri_profili"} page={"popupHook"}/></h4>
						<img width="190px" src="img/donne_disponibili.gif"/>
						<p><Lang w={"incentive_3"} page={"popupHook"}/></p>
					</div>
					<Button onClick={() => {ReactGA.event({ category: 'User',action: 'Click su hook',label:'Paginazione'});navigate('/vip_plan/'+context.flusso.hooks.paginazione);context.setModalShowHook(false)}}> <Lang w={"diventa_premium"} page={"popupHook"}/></Button>
				</div>
			</div>
		  </Modal.Body>
		</Modal>);
	}
	if(props.provenienza == "fine_crediti"){

		
		 
		return (  <Modal
			{...props}
			size="md"
			aria-labelledby="contained-modal-title-vcenter"
			centered
			dialogClassName="popuphook fineCrediti"
			animation={false}
		  >
			<Modal.Body>
			  <div className="popupbackground" style={{backgroundImage: `url(${imageUrl})` }} >
				  <span className="closeHook" onClick={()=>{context.setModalShowHook(false);}}>X</span>
				  <div className="contentBackground ">
					  <div className="hookTextContainer">
						<div className="contenitoreMessaggioAlert">
							<p><i className="fa fa-exclamation-triangle"> </i> <Lang w={"messaggio_sospeso"} page={"popupHook"}/></p>
							<img src={imageUrl} alt="" className="imageInHook"/>
						</div>
						<h4><Lang w={"non_lasciare_sospeso"} page={"popupHook"} placeholders={{angel:props.angel.screenName}}/></h4>
						
						<h4><Lang w={"attiva_pass"} page={"popupHook"} placeholders={{angel:props.angel.screenName}}/></h4>
					  </div>
					  <Button onClick={() => {ReactGA.event({ category: 'User',action: 'Click su hook',label:'Fine crediti'});context.setPaymentPageText({header1:"pagamento_sicuro",header2:"dati_protetti",text1:undefined});navigate('/vip_plan/'+context.flusso.hooks.fine_crediti);context.setModalShowHook(false)}}> <Lang w={"continua"} page={"popupHook"}/></Button>
				  </div>
			  </div>
			</Modal.Body>
		  </Modal>);
	}if(props.provenienza == "attiva_lettura"){

		 
		return (  <Modal
			{...props}
			size="md"
			aria-labelledby="contained-modal-title-vcenter"
			centered
			dialogClassName="popuphook fineCrediti"
			animation={false}
		  >
			<Modal.Body>
			  <div className="popupbackground" style={{backgroundImage: `url(${imageUrl})` }} >
				  <span className="closeHook" onClick={()=>{context.setModalShowHook(false);}}>X</span>
				  <div className="contentBackground ">
					  <div className="hookTextContainer">
						<div className="contenitoreMessaggioAlert">
							
							<img src={imageUrl} alt="" className="imageInHook"/>
						</div>
						
						<h4><Lang w={"attiva_lettura"} page={"popupHook"} placeholders={{angel:props.angel.screenName}}/></h4>
					  </div>
					  <Button onClick={() => {ReactGA.event({ category: 'User',action: 'Click su hook',label:'Fine crediti'});context.setPaymentPageText({header1:"pagamento_sicuro",header2:"dati_protetti",text1:undefined});navigate('/vip_plan/'+context.flusso.hooks.fine_crediti);context.setModalShowHook(false)}}> <Lang w={"continua"} page={"popupHook"}/></Button>
				  </div>
			  </div>
			</Modal.Body>
		  </Modal>);
	}
	if(props.provenienza == "file_like"){

		return (  <Modal
			{...props}
			size="lg"
			aria-labelledby="contained-modal-title-vcenter"
			centered
			dialogClassName="popuphook"
			animation={false}
		  >
			<Modal.Body>
			  <div className="popupbackground" style={{backgroundImage: `url(${imageUrl})` }} >
				  <span className="closeHook" onClick={()=>{context.setModalShowHook(false);}}>X</span>
				  <div className="contentBackground ">
					  <div className="hookTextContainer">
						<h3><Lang w={"ti_piace"} page={"popupHook"}/> {props.angel.screenName}?</h3>
						<img src={imageUrl} alt="" className="imageInHook"/>
						<p><Lang w={"attiva_generico"} page={"popupHook"}/></p>
					  </div>
					  <Button onClick={() => {ReactGA.event({ category: 'User',action: 'Click su hook',label:'Fine likes'});navigate('/vip_plan/'+context.flusso.hooks.file_like);context.setModalShowHook(false)}}> <Lang w={"continua"} page={"popupHook"}/></Button>
				  </div>
			  </div>
			</Modal.Body>
		  </Modal>);
	}
	if(props.provenienza == "utente_premium"){

		return (  <Modal
			{...props}
			size="lg"
			aria-labelledby="contained-modal-title-vcenter"
			centered
			dialogClassName="popuphook"
			animation={false}
		  >
			<Modal.Body>
			  <div className="popupbackground" style={{backgroundImage: `url(${imageUrl})` }} >
				  <span className="closeHook" onClick={()=>{context.setModalShowHook(false);}}>X</span>
				  <div className="contentBackground ">
					  <div className="hookTextContainer">
						<h4><strong> {props.angel.screenName}</strong> <Lang w={"utente_registrato"} page={"popupHook"}/></h4>
						<img src={imageUrl} alt="" className="imageInHook"/>
						<p><Lang w={"per_scoprire"} page={"popupHook"} placeholders={{angel:props.angel.screenName}}/></p>
						<h5><Lang w={"la_vuoi_conoscere"} page={"popupHook"}/> <strong>{props.angel.screenName}</strong>?</h5>
					  </div>
					  <Button onClick={() => {
						  	context.setPaymentPageText({...context.paymentPageText,text1:"non_paghi_nulla",header1:"verifica_profilo"});
							context.setRateplanScelto(context.rateplanScelto)
							//ReactGA.event({ category: 'User',action: 'Click su hook',label:'Verifica profilo'})
						  	navigate('/purchase');
							  context.setModalShowHook(false)
						}}> <Lang w={"verifica_profilo"} page={"popupHook"}/></Button>
				  </div>
			  </div>
			</Modal.Body>
		  </Modal>);
	}if(props.provenienza == "cambia_regione"){
		
		return (  <Modal
			{...props}
			size="lg"
			aria-labelledby="contained-modal-title-vcenter"
			centered
			dialogClassName="popuphook"
			animation={false}
		  >
			<Modal.Body>
			  <div className="popupbackground" >
				  <span className="closeHook" onClick={()=>{context.setModalShowHook(false);}}>X</span>
				  <div className="contentBackground ">
					  <div className="hookTextContainer">
						<h3><Lang w={"donne_regione"} page={"popupHook"}/></h3>
						<img width="190px" src="img/donne_disponibili.gif"/>
						<p><Lang w={"sottotitolo_regione"} page={"popupHook"}/></p>
					  </div>
					  <Button onClick={() => {
						  	//ReactGA.event({ category: 'User',action: 'Click su hook'})
						  	navigate('/vip_plan/'+context.flusso.hooks.cambia_regione);
							  context.setModalShowHook(false)
						}}> <Lang w={"continua"} page={"popupHook"}/></Button>
				  </div>
			  </div>
			</Modal.Body>
		  </Modal>);
	}
	if(props.provenienza == "utente_premium_compliant"){

		return (  <Modal
			{...props}
			size="lg"
			aria-labelledby="contained-modal-title-vcenter"
			centered
			dialogClassName="popuphook"
			animation={false}
		  >
			<Modal.Body>
			  <div className="popupbackground" style={{backgroundImage: `url(${imageUrl})` }} >
				  <span className="closeHook" onClick={()=>{context.setModalShowHook(false);}}>X</span>
				  <div className="contentBackground ">
					  <div className="hookTextContainer">
						<h3><strong> {props.angel.screenName}</strong> <Lang w={"utente_registrato"} page={"popupHook"}/></h3>
						<img src={imageUrl} alt="" className="imageInHook"/>
						<p><Lang w={"attiva_generico"} page={"popupHook"}/></p>
						
					  </div>
					  <Button onClick={() => {navigate('/vip_plan/cred');context.setModalShowHook(false)}}> <Lang w={"continua"} page={"popupHook"}/></Button>
				  </div>
			  </div>
			</Modal.Body>
		  </Modal>);
	}
	
	if(props.provenienza == "iframe"){
        

        return (<div>
          
          <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            fullscreen={true}
          dialogClassName="popupgenerico"
		  animation={false}
          >
            
            <Modal.Body>
           
                 <iframe width={"100%"} height={"700px"} frameBorder={false} src={props.contenuto.url} sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-pointer-lock"></iframe>
            </Modal.Body>

          </Modal>
        </div>)
      }

	  if(props.provenienza == "utente_disabilitato"){
		
		return ( <Modal
			{...props}
			size="lg"
			aria-labelledby="contained-modal-title-vcenter"
			centered
			fullscreen={true}
			dialogClassName="popuphook"
			animation={false}
		  >
			<Modal.Body>
			  <div className="popupbackground">
				  <div className="doiHook">
				  	<Lang w={"utente_disabilitato"} page={"popupHook"}/>
				  </div>
			  </div>
			</Modal.Body>
		  </Modal>);
	}  

	if(props.provenienza == "doi"){
		return ( <Modal
			{...props}
			size="lg"
			aria-labelledby="contained-modal-title-vcenter"
			centered
			fullscreen={true}
			dialogClassName="popuphook"
			animation={false}
		  >
			<Modal.Body>
			  <div className="popupbackground">
				  <div className="doiHook">
				  	<Doi {... props}/>
				  </div>
			  </div>
			</Modal.Body>
		  </Modal>);
	}
	// ------------- Questo avviene dopo il login with google
	if(props.provenienza == "impostaRegione"){
		return <ImpostaRegione {...props}/>
	}
	
	if(location[1] == ""){
		return ( <Modal
		  {...props}
		  size="lg"
		  aria-labelledby="contained-modal-title-vcenter"
		  centered
		  dialogClassName="popuphook"
		  animation={false}
		>
		  <Modal.Body>
			<div className="popupbackground" style={{backgroundColor:`rgba(0,0,0,0.2)`}}>
			<span className="closeHook" onClick={props.onHide}>X</span>
				<div className="contentBackground signupHook">
					<SignupForm {...props}/>
				</div>
			</div>
		  </Modal.Body>
		</Modal>);
	}
	
	else{
		return ( <Modal
		  {...props}
		  size="lg"
		  aria-labelledby="contained-modal-title-vcenter"
		  centered
		  fullscreen={true}
		  dialogClassName="popuphook"
		  animation={false}
		>
		  <Modal.Body>
			<div className="popupbackground">
				<div className="contentBackground signupHook">
					<SignupForm {...props}/>
				</div>
			</div>
		  </Modal.Body>
		</Modal>);
	}

}







